import { render, staticRenderFns } from "./Classmates.vue?vue&type=template&id=40053af6"
import script from "./Classmates.vue?vue&type=script&lang=js"
export * from "./Classmates.vue?vue&type=script&lang=js"
import style0 from "./Classmates.vue?vue&type=style&index=0&id=40053af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports